/**
 * Runtime Environment Variables
 *
 * For S3 deployments - values computed at runtime based on domain.
 * Based on: recruiter-ui/app/runtimeEnvVars.js
 */

import { domainMeta } from '@/utils/domain-meta';

// Tenants with a dedicated hire cluster pin the wx release channel via Helm
// ConfigMap injection (see apps/hire/helm/tenants/aimbridge-na/values.yaml).
// VITE_* vars are baked at build time, so pod env overrides have no effect
// here. This map provides a hostname-derived browser-layer fallback for all
// custom-deploy tenants (both those with and without a dedicated hire cluster,
// including UPS which runs on shared infra).
const TENANT_WX_RELEASE_CHANNELS: Record<string, string> = {
  aimbridge: 'aimbridge',
  ups: 'ups',
};

export const WX_NAVBAR_VERSION = 'v3';

export const WX_NAVBAR_RELEASE_CHANNEL: string =
  import.meta.env.VITE_WX_NAVBAR_RELEASE_CHANNEL ??
  TENANT_WX_RELEASE_CHANNELS[domainMeta.tenant] ??
  (domainMeta.environment === 'prod' ? 'stable' : 'main');

export const WX_NAVBAR_URL: string =
  import.meta.env.VITE_WX_NAVBAR_URL ??
  `https://ftn-shared-components.fountain.com/wx-navbar/${WX_NAVBAR_VERSION}/release/${WX_NAVBAR_RELEASE_CHANNEL}/wx-navbar.umd.js`;

export const WX_COPILOT_VERSION = 'v8';

export const WX_COPILOT_RELEASE_CHANNEL: string =
  import.meta.env.VITE_WX_COPILOT_RELEASE_CHANNEL ??
  TENANT_WX_RELEASE_CHANNELS[domainMeta.tenant] ??
  (domainMeta.environment === 'prod' ? 'stable' : 'main');

export const WX_COPILOT_URL: string =
  import.meta.env.VITE_WX_COPILOT_URL ??
  `https://ftn-shared-components.fountain.com/wx-copilot/${WX_COPILOT_VERSION}/release/${WX_COPILOT_RELEASE_CHANNEL}/wx-copilot.umd.js`;

export const WX_LAUNCH_DARKLY_CLIENT_SIDE_ID: string =
  import.meta.env.VITE_WX_LAUNCH_DARKLY_CLIENT_SIDE_ID ??
  domainMeta.launchDarklyClientSideId;

export const I18N_LOG_MISSING_TRANSLATIONS =
  import.meta.env.VITE_I18N_LOG_MISSING_TRANSLATIONS ?? 'false';

export const POSTHOG_HOST: string =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? '';
export const POSTHOG_API_KEY: string =
  (import.meta.env.VITE_POSTHOG_API_KEY as string | undefined) ?? '';
export const POSTHOG_DEBUG: string =
  (import.meta.env.VITE_POSTHOG_DEBUG as string | undefined) ?? '';
